import { Content } from "@radix-ui/react-tabs";
import { Root } from "./components/Root";
import { List } from "./components/List";
import { Trigger } from "./components/Trigger";
import { TriggerIcon } from "./components/TriggerIcon";
import { TriggerLabel } from "./components/TriggerLabel";

// Create namespace object for exports
export const Tabs = {
  Root,
  List,
  Trigger,
  TriggerIcon,
  TriggerLabel,
  Content
};

// Export types directly
export * from "./types";
